import { Building2, ChevronRight, Loader2 } from 'lucide-react';
import { OrganizationCardProps } from './types';

const OrganizationCard = (props: OrganizationCardProps) => {
  const {
    isLoading,
    navigate,
    organization
  } = props;

  const onClickOpenOrganizationEdit = (): void => {
    navigate('/profile/organization/edit');
  };

  if (isLoading || !organization) {
    return (
      <article className="flex min-h-[88px] items-center justify-center p-4 rounded-2xl border border-border-strong bg-surface">
        <Loader2 className="size-5 animate-spin text-muted-foreground" />
      </article>
    );
  }

  return (
    <button
      className="flex w-full items-center gap-2 p-4 text-left rounded-2xl border border-border-strong bg-surface transition-colors hover:bg-accent-soft/60 active:bg-[#F3F5FF] dark:active:bg-[#201F27] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      aria-label="Открыть организацию"
      onClick={onClickOpenOrganizationEdit}
      type="button"
    >
      <div className="flex min-w-0 flex-1 items-start gap-2">
        <div className="flex size-8 shrink-0 items-center justify-center rounded-[8px] bg-[#13100d0d] dark:bg-[#ffffff0d]">
          <Building2 className="size-4 text-foreground" />
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <h3 className="truncate font-sans text-[16px] font-semibold leading-5 tracking-normal text-foreground">
            {organization.name}
          </h3>
          <div className="flex flex-col text-xs leading-4 text-muted-foreground">
            <p className="truncate">ИНН: {organization.inn}</p>
            {organization.kpp ? (
              <p className="truncate">КПП: {organization.kpp}</p>
            ) : null}
          </div>
        </div>
      </div>
      <ChevronRight className="size-5 shrink-0 text-muted-foreground" />
    </button>
  );
};

export default OrganizationCard;